import * as React from 'react';
import { useMediaQuery } from '@material-ui/core';
import { ShowButton, List, Datagrid, TextField, SimpleList } from 'react-admin';

export const FeedbackList = (props) => {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <List
      title="All feedbacks"
      {...props}
      filter={{
        status: 'open',
      }}
    >
      {isSmall ? (
        <SimpleList
          primaryText={(record) => record.detail}
          secondaryText={(record) => record.type}
          tertiaryText={(record) => record.createdAt}
        />
      ) : (
        <Datagrid>
          <TextField source="detail" />
          <TextField source="userId" />
          <TextField source="type" />
          <TextField source="createdAt" />
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};
